import React, { useState, useEffect } from "react";
import axios from "axios";
import nizlogo from "../../assets/nizlogo.png";
import { 
  FaUser, 
  FaPhone, 
  FaIdCard, 
  FaSchool, 
  FaCalendarAlt, 
  FaBuilding, 
  FaClock, 
  FaGraduationCap, 
  FaInfoCircle, 
  FaExclamationTriangle,
  FaCheckCircle,
  FaPaperPlane,
  FaArrowRight,
  FaCog,
  FaEdit,
  FaSave,
  FaPlus,
  FaTrash,
  FaList,
  FaEye,
  FaUserShield
} from "react-icons/fa";
import { toast, Toaster } from "react-hot-toast";

const ExamRegistrationForm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1); // Çok adımlı form için
  const [errors, setErrors] = useState({});
  
  // Admin paneli state'leri
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdminPanelOpen, setIsAdminPanelOpen] = useState(false);
  const [examRecords, setExamRecords] = useState([]);
  const [showRecords, setShowRecords] = useState(false);
  const [adminLoading, setAdminLoading] = useState(false);
  
  // Form konfigürasyonu
  const [formConfig, setFormConfig] = useState({
    title: "ESN AKADEMİ SINAV KAYIT FORMU",
    institution: "ESN AKADEMİ",
    classLevels: [
      { value: "5.sınıf", label: "5. Sınıf" },
      { value: "6.sınıf", label: "6. Sınıf" },
      { value: "7.sınıf", label: "7. Sınıf" }
    ],
    examDates: [
      { value: "CUMARTESİ", label: "11.01.2025 CUMARTESİ" },
      { value: "PAZAR", label: "12.01.2025 PAZAR" }
    ],
    examSessions: [
      { value: "10:00", label: "10:00" },
      { value: "13:00", label: "13:00" },
      { value: "15:00", label: "15:00" }
    ],
    infoText: {
      title: "Sınav Bilgilendirmesi",
      items: [
        "Lütfen gerekli bilgilerin tümünü eksiksiz doldurunuz.",
        "Sınava cep telefonu ile girilmesi yasaktır.",
        "Sınava gelirken kimlik belgenizi yanınızda bulundurmanız gerekmektedir.",
        "Sınav başlamadan 15 dakika önce salondaki yerinizi almanız rica olunur."
      ]
    }
  });
  
  // Form verisi
  const [formData, setFormData] = useState({
    class_level: "",
    institution: "ESN",
    exam_date: "",
    exam_session: "",
    student_id: "",
    student_name: "",
    student_surname: "",
    student_birth_year: "",
    student_phone: "",
    school: "",
    father_name: "",
    father_phone: "",
    mother_name: "",
    mother_phone: "",
  });

  // Admin kontrolü
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    console.log('Auth Token:', token ? 'Mevcut' : 'Yok');
    
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('Token Payload:', payload);
        // Bazı JWT payload'larında rol bilgisi payload.data.role içinde olabilir
        const role = payload.role || (payload.data && payload.data.role);
        console.log('User Role:', role);
        const adminStatus = role === 'admin';
        console.log('Is Admin:', adminStatus);
        setIsAdmin(adminStatus);
      } catch (error) {
        console.error('Token decode hatası:', error);
        setIsAdmin(false);
      }
    } else {
      console.log('Token bulunamadı, admin erişimi kapalı');
      setIsAdmin(false);
    }
  }, []);

  // Exam kayıtlarını getirme
  const fetchExamRecords = async () => {
    if (!isAdmin) return;
    
    setAdminLoading(true);
    const token = localStorage.getItem("authToken");
    
    try {
      const timestamp = new Date().getTime();
      const response = await axios.get(`http://esnakademi.com/api/exam_list?_t=${timestamp}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (Array.isArray(response.data)) {
        setExamRecords(response.data);
      } else {
        setExamRecords([]);
      }
    } catch (error) {
      console.error("Sınav kayıtları alınırken hata:", error);
      toast.error("Sınav kayıtları yüklenemedi");
      setExamRecords([]);
    } finally {
      setAdminLoading(false);
    }
  };

  // Form konfigürasyonunu kaydetme
  const saveFormConfig = async () => {
    if (!isAdmin) return;
    
    setAdminLoading(true);
    const token = localStorage.getItem("authToken");
    
    try {
      await axios.post("http://esnakademi.com/api/exam-config", formConfig, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      
      toast.success("Form konfigürasyonu kaydedildi!");
    } catch (error) {
      console.error("Form konfigürasyonu kaydedilirken hata:", error);
      toast.error("Konfigürasyon kaydedilemedi");
    } finally {
      setAdminLoading(false);
    }
  };

  // Form konfigürasyonunu yükleme - Herkes için veritabanından çekilir
  const loadFormConfig = async () => {
    try {
      const timestamp2 = new Date().getTime();
      const response = await axios.get(`http://esnakademi.com/api/exam-config?_t=${timestamp2}`);
      
      if (response.data) {
        setFormConfig(response.data);
      }
    } catch (error) {
      console.error("Form konfigürasyonu yüklenirken hata:", error);
      // Hata durumunda varsayılan konfigürasyonu koru
    }
  };

  // Sayfa yüklendiğinde konfigürasyonu veritabanından al
  useEffect(() => {
    loadFormConfig();
  }, []);

  // TC Kimlik doğrulama fonksiyonu
  const validateTCID = (id) => {
    if (!id) return false;
    if (id.length !== 11) return false;
    if (!/^\d+$/.test(id)) return false; // Sadece rakamlardan oluşmalı
    
    // İlk hane 0 olamaz
    if (id[0] === '0') return false;
    
    return true;
  };

  // Telefon numarası doğrulama
  const validatePhone = (phone) => {
    if (!phone) return false;
    return /^[0-9]{10,11}$/.test(phone);
  };

  // Veli telefon numaralarından en az birinin doğrulaması
  const validateParentPhone = () => {
    return validatePhone(formData.father_phone) || validatePhone(formData.mother_phone);
  };

  // Form alanlarının doğrulaması
  const validateForm = () => {
    const newErrors = {};
    
    // Ad soyad kontrolü
    if (!formData.student_name.trim()) {
      newErrors.student_name = "Öğrenci adı zorunludur";
    }
    
    if (!formData.student_surname.trim()) {
      newErrors.student_surname = "Öğrenci soyadı zorunludur";
    }
    
    // TC Kimlik kontrolü
    if (!validateTCID(formData.student_id)) {
      newErrors.student_id = "Geçerli bir TC Kimlik numarası giriniz (11 haneli)";
    }
    
    // Anne baba kontrolü
    if (!formData.father_name.trim()) {
      newErrors.father_name = "Baba adı soyadı zorunludur";
    }
    
    if (!formData.mother_name.trim()) {
      newErrors.mother_name = "Anne adı soyadı zorunludur";
    }
    
    // Telefon kontrolü - En az bir veli telefonu zorunlu
    if (!validateParentPhone()) {
      newErrors.parent_phone = "En az bir veli telefon numarası gereklidir";
    }
    
    // Okul kontrolü
    if (!formData.school.trim()) {
      newErrors.school = "Okul bilgisi zorunludur";
    }
    
    // Sınav oturum bilgileri kontrolü
    if (!formData.class_level) {
      newErrors.class_level = "Sınıf seviyesi seçiniz";
    }
    
    if (!formData.exam_date) {
      newErrors.exam_date = "Sınav tarihi seçiniz";
    }
    
    if (!formData.exam_session) {
      newErrors.exam_session = "Sınav oturumu seçiniz";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Özel doğrulama ve formatlama
    if (name === "student_id") {
      // Sadece rakam ve en fazla 11 karakter
      const numericValue = value.replace(/\D/g, '').slice(0, 11);
      setFormData(prev => ({ ...prev, [name]: numericValue }));
      return;
    }
    
    if (name === "father_phone" || name === "mother_phone" || name === "student_phone") {
      // Telefon numarası formatlaması
      const numericValue = value.replace(/\D/g, '').slice(0, 11);
      setFormData(prev => ({ ...prev, [name]: numericValue }));
      return;
    }
    
    // Tarih alanları - YYYY-MM-DD formatı (date input)
    if (name === 'student_birth_year') {
      setFormData(prev => ({ ...prev, [name]: value }));
      return;
    }
    
    // İsim alanları için capitalize işlemi
    const nameFields = [
      'student_name', 'student_surname', 'father_name', 'mother_name', 'school'
    ];
    
    let processedValue = value;
    
    if (nameFields.includes(name)) {
      // Her kelimenin ilk harfini büyük yap
      processedValue = value
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
    
    // Diğer alanlar için normal güncelleme
    setFormData(prev => ({ ...prev, [name]: processedValue }));
  };

  // Formu bir sonraki adıma ilerletme
  const handleNextStep = () => {
    if (step === 1) {
      const sessionValid = formData.class_level && formData.exam_date && formData.exam_session;
      if (!sessionValid) {
        toast.error("Lütfen tüm oturum bilgilerini doldurun");
        validateForm();
        return;
      }
      setStep(2);
    } else if (step === 2) {
      const studentValid = formData.student_name && formData.student_surname && validateTCID(formData.student_id) && formData.school;
      if (!studentValid) {
        toast.error("Lütfen öğrenci bilgilerini eksiksiz doldurun");
        validateForm();
        return;
      }
      setStep(3);
    }
  };

  // Formu bir önceki adıma geri döndürme
  const handlePrevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Form doğrulaması
    if (!validateForm()) {
      toast.error("Lütfen formdaki hataları düzeltin");
      return;
    }
    
    // Onay kutusu kontrolü
    if (!isChecked) {
      toast.error("Lütfen bilgilendirme onayını işaretleyin");
      return;
    }
    
    setLoading(true);
    
    // Tam isim oluştur
    const fullFormData = {
      ...formData,
      student_name: formData.student_name + " " + formData.student_surname,
    };
    
    try {
      const loadingToast = toast.loading("Kayıt gönderiliyor...");
      
      await axios.post("http://esnakademi.com/api/exam_list", fullFormData);
      
      toast.dismiss(loadingToast);
      toast.success("Kayıt başarıyla tamamlandı!");
      setIsModalOpen(true); // Modalı aç
    } catch (error) {
      console.error("Kayıt sırasında bir hata oluştu:", error);
      toast.error("Kayıt oluşturulurken bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Modalı kapat
    // Formu sıfırla
    setFormData({
      class_level: "",
      institution: "ESN",
      exam_date: "",
      exam_session: "",
      student_id: "",
      student_name: "",
      student_surname: "",
      student_birth_year: "",
      student_phone: "",
      school: "",
      father_name: "",
      father_phone: "",
      mother_name: "",
      mother_phone: "",
    });
    setIsChecked(false);
    setStep(1);
    window.scrollTo(0, 0);
  };

  return (
    <div
      translate="no"
      className="w-full min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex justify-center items-start px-2 sm:px-4"
    >
      <Toaster position="top-right" />
      
      <div className="p-3 sm:p-4 lg:p-6 w-full max-w-4xl lg:max-w-5xl bg-white shadow-lg rounded-xl flex flex-col my-4 sm:my-6 lg:my-10">
        {/* Header */}
        <div className="flex flex-col items-center mb-4 sm:mb-6">
          <img className="w-1/2 sm:w-1/3 max-w-xs" alt="esn-logo" src={nizlogo} />
          <h1 className="text-lg sm:text-2xl lg:text-3xl font-bold text-indigo-700 mt-3 sm:mt-4 lg:mt-6 text-center px-2">
            {formConfig.title}
          </h1>
          <div className="w-16 sm:w-20 h-1 bg-indigo-500 mt-2 sm:mt-4 mb-4 sm:mb-6"></div>
          
          {/* Admin Buton */}
          {console.log('Render - isAdmin:', isAdmin)}
          {isAdmin ? (
            <div className="flex gap-2 mb-4">
              <button
                onClick={() => setIsAdminPanelOpen(!isAdminPanelOpen)}
                className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors"
              >
                <FaUserShield className="text-sm" />
                Admin Panel
              </button>
              <button
                onClick={() => {
                  fetchExamRecords();
                  setShowRecords(!showRecords);
                }}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors"
              >
                <FaList className="text-sm" />
                Kayıtlar ({examRecords.length})
              </button>
            </div>
          ) : null}
        </div>

        {/* Admin Panel */}
        {isAdmin && isAdminPanelOpen && (
          <div className="mb-6 bg-purple-50 border border-purple-200 rounded-lg p-4">
            <h2 className="text-lg font-bold text-purple-800 mb-4 flex items-center gap-2">
              <FaCog className="text-purple-600" />
              Form Konfigürasyonu
            </h2>
            
            <div className="space-y-4">
              {/* Form Başlığı */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Form Başlığı</label>
                <input
                  type="text"
                  value={formConfig.title}
                  onChange={(e) => setFormConfig({...formConfig, title: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                />
              </div>
              
              {/* Kurum Adı */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Kurum Adı</label>
                <input
                  type="text"
                  value={formConfig.institution}
                  onChange={(e) => setFormConfig({...formConfig, institution: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                />
              </div>
              
              {/* Sınav Tarihleri */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Sınav Tarihleri</label>
                <div className="space-y-2">
                  {formConfig.examDates.map((date, index) => (
                    <div key={index} className="flex gap-2">
                      <input
                        type="text"
                        value={date.value}
                        onChange={(e) => {
                          const newDates = [...formConfig.examDates];
                          newDates[index].value = e.target.value;
                          setFormConfig({...formConfig, examDates: newDates});
                        }}
                        className="flex-1 border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                        placeholder="Değer"
                      />
                      <input
                        type="text"
                        value={date.label}
                        onChange={(e) => {
                          const newDates = [...formConfig.examDates];
                          newDates[index].label = e.target.value;
                          setFormConfig({...formConfig, examDates: newDates});
                        }}
                        className="flex-1 border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                        placeholder="Gösterilecek Metin"
                      />
                      <button
                        onClick={() => {
                          const newDates = formConfig.examDates.filter((_, i) => i !== index);
                          setFormConfig({...formConfig, examDates: newDates});
                        }}
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg"
                      >
                        <FaTrash className="text-sm" />
                      </button>
                    </div>
                  ))}
                  <button
                    onClick={() => {
                      const newDates = [...formConfig.examDates, {value: "", label: ""}];
                      setFormConfig({...formConfig, examDates: newDates});
                    }}
                    className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg flex items-center gap-2"
                  >
                    <FaPlus className="text-sm" /> Tarih Ekle
                  </button>
                </div>
              </div>
              
              {/* Sınav Oturumları */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Sınav Oturumları</label>
                <div className="space-y-2">
                  {formConfig.examSessions.map((session, index) => (
                    <div key={index} className="flex gap-2">
                      <input
                        type="text"
                        value={session.value}
                        onChange={(e) => {
                          const newSessions = [...formConfig.examSessions];
                          newSessions[index].value = e.target.value;
                          setFormConfig({...formConfig, examSessions: newSessions});
                        }}
                        className="flex-1 border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                        placeholder="Saat"
                      />
                      <input
                        type="text"
                        value={session.label}
                        onChange={(e) => {
                          const newSessions = [...formConfig.examSessions];
                          newSessions[index].label = e.target.value;
                          setFormConfig({...formConfig, examSessions: newSessions});
                        }}
                        className="flex-1 border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                        placeholder="Gösterilecek Metin"
                      />
                      <button
                        onClick={() => {
                          const newSessions = formConfig.examSessions.filter((_, i) => i !== index);
                          setFormConfig({...formConfig, examSessions: newSessions});
                        }}
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg"
                      >
                        <FaTrash className="text-sm" />
                      </button>
                    </div>
                  ))}
                  <button
                    onClick={() => {
                      const newSessions = [...formConfig.examSessions, {value: "", label: ""}];
                      setFormConfig({...formConfig, examSessions: newSessions});
                    }}
                    className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg flex items-center gap-2"
                  >
                    <FaPlus className="text-sm" /> Oturum Ekle
                  </button>
                </div>
              </div>
              
              {/* Bilgilendirme Başlığı */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Bilgilendirme Başlığı</label>
                <input
                  type="text"
                  value={formConfig.infoText.title}
                  onChange={(e) => setFormConfig({
                    ...formConfig,
                    infoText: {...formConfig.infoText, title: e.target.value}
                  })}
                  className="w-full border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                />
              </div>
              
              {/* Bilgilendirme Maddeleri */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Bilgilendirme Maddeleri</label>
                <div className="space-y-2">
                  {formConfig.infoText.items.map((item, index) => (
                    <div key={index} className="flex gap-2">
                      <input
                        type="text"
                        value={item}
                        onChange={(e) => {
                          const newItems = [...formConfig.infoText.items];
                          newItems[index] = e.target.value;
                          setFormConfig({
                            ...formConfig,
                            infoText: {...formConfig.infoText, items: newItems}
                          });
                        }}
                        className="flex-1 border border-gray-300 rounded-lg p-2 focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
                      />
                      <button
                        onClick={() => {
                          const newItems = formConfig.infoText.items.filter((_, i) => i !== index);
                          setFormConfig({
                            ...formConfig,
                            infoText: {...formConfig.infoText, items: newItems}
                          });
                        }}
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg"
                      >
                        <FaTrash className="text-sm" />
                      </button>
                    </div>
                  ))}
                  <button
                    onClick={() => {
                      const newItems = [...formConfig.infoText.items, ""];
                      setFormConfig({
                        ...formConfig,
                        infoText: {...formConfig.infoText, items: newItems}
                      });
                    }}
                    className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg flex items-center gap-2"
                  >
                    <FaPlus className="text-sm" /> Madde Ekle
                  </button>
                </div>
              </div>
              
              {/* Kaydet Butonu */}
              <div className="flex justify-end">
                <button
                  onClick={saveFormConfig}
                  disabled={adminLoading}
                  className={`${
                    adminLoading ? 'bg-purple-400' : 'bg-purple-600 hover:bg-purple-700'
                  } text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-colors`}
                >
                  {adminLoading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Kaydediliyor...
                    </>
                  ) : (
                    <>
                      <FaSave className="text-sm" />
                      Kaydet
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Kayıtlar Listesi */}
        {isAdmin && showRecords && (
          <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4">
            <h2 className="text-lg font-bold text-green-800 mb-4 flex items-center gap-2">
              <FaList className="text-green-600" />
              Sınav Kayıtları ({examRecords.length})
            </h2>
            
            {adminLoading ? (
              <div className="text-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto"></div>
                <p className="text-green-600 mt-2">Kayıtlar yükleniyor...</p>
              </div>
            ) : examRecords.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                <FaExclamationTriangle className="text-3xl mb-2 mx-auto" />
                <p>Henüz sınav kaydı bulunmamaktadır.</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-green-100">
                    <tr>
                      <th className="text-left p-2">Öğrenci</th>
                      <th className="text-left p-2">TC</th>
                      <th className="text-left p-2">Sınıf</th>
                      <th className="text-left p-2">Tarih</th>
                      <th className="text-left p-2">Oturum</th>
                      <th className="text-left p-2">Okul</th>
                      <th className="text-left p-2">Baba Tel</th>
                      <th className="text-left p-2">Anne Tel</th>
                    </tr>
                  </thead>
                  <tbody>
                    {examRecords.map((record, index) => (
                      <tr key={index} className="border-b border-green-200">
                        <td className="p-2 font-medium">{record.student_name}</td>
                        <td className="p-2">{record.student_id}</td>
                        <td className="p-2">{record.class_level}</td>
                        <td className="p-2">{record.exam_date}</td>
                        <td className="p-2">{record.exam_session}</td>
                        <td className="p-2">{record.school}</td>
                        <td className="p-2">{record.father_phone}</td>
                        <td className="p-2">{record.mother_phone}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
        
        {/* İlerleme çubuğu */}
        <div className="mb-4 sm:mb-6 lg:mb-8">
          <div className="flex justify-between items-center">
            <div className={`flex flex-col items-center ${step >= 1 ? 'text-indigo-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-base
                ${step >= 1 ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-500'}`}>
                1
              </div>
              <span className="text-xs sm:text-sm mt-1">Oturum</span>
            </div>
            <div className={`flex-1 h-1 mx-1 sm:mx-2 ${step >= 2 ? 'bg-indigo-600' : 'bg-gray-200'}`}></div>
            <div className={`flex flex-col items-center ${step >= 2 ? 'text-indigo-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-base
                ${step >= 2 ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-500'}`}>
                2
              </div>
              <span className="text-xs sm:text-sm mt-1">Öğrenci</span>
            </div>
            <div className={`flex-1 h-1 mx-1 sm:mx-2 ${step >= 3 ? 'bg-indigo-600' : 'bg-gray-200'}`}></div>
            <div className={`flex flex-col items-center ${step >= 3 ? 'text-indigo-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-base
                ${step >= 3 ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-500'}`}>
                3
              </div>
              <span className="text-xs sm:text-sm mt-1">Veli</span>
            </div>
          </div>
        </div>
        
        {/* Bilgilendirme kartı */}
        <div className="bg-blue-50 border-l-4 border-blue-500 p-3 sm:p-4 mb-4 sm:mb-6 lg:mb-8 rounded-lg">
          <div className="flex">
            <FaInfoCircle className="text-blue-500 text-lg sm:text-xl flex-shrink-0 mr-2 sm:mr-3 mt-1" />
            <div>
              <h4 className="font-bold text-blue-800 text-sm sm:text-base">{formConfig.infoText.title}</h4>
              <ul className="text-xs sm:text-sm text-blue-700 mt-1 sm:mt-2 space-y-1">
                {formConfig.infoText.items.map((item, index) => (
                  <li key={index}>• {item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Form */}
        <form
          id="myForm"
          onSubmit={handleSubmit}
          className="flex flex-col justify-center w-full"
        >
          {/* Adım 1: Oturum Bilgileri */}
          {step === 1 && (
            <div className="transition-opacity duration-300">
              <h2 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 flex items-center text-indigo-800">
                <FaCalendarAlt className="mr-2 text-sm sm:text-base" /> Oturum Bilgileri
              </h2>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 sm:gap-x-6 lg:gap-x-8 gap-y-3 sm:gap-y-4">
                                  <div>
                    <label className="block mb-1 font-medium text-gray-700 text-sm sm:text-base">
                      <span className="text-red-500">*</span> Sınıf Seviyesi
                    </label>
                                      <div className="relative">
                      <FaGraduationCap className="absolute left-2 sm:left-3 top-2.5 sm:top-3 text-gray-400 text-sm sm:text-base" />
                      <select
                        name="class_level"
                        value={formData.class_level}
                        onChange={handleChange}
                        className={`w-full border rounded-lg p-2 sm:p-3 pl-8 sm:pl-10 text-sm sm:text-base focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 ${
                          errors.class_level ? 'border-red-500' : 'border-gray-300'
                        }`}
                      >
                      <option value="">Seçiniz</option>
                      {formConfig.classLevels.map((level, index) => (
                        <option key={index} value={level.value}>{level.label}</option>
                      ))}
                    </select>
                  </div>
                  {errors.class_level && (
                    <p className="text-red-500 text-xs mt-1">{errors.class_level}</p>
                  )}
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Kurum
                  </label>
                  <div className="relative">
                    <FaBuilding className="absolute left-3 top-3 text-gray-400" />
                    <select
                      name="institution"
                      value={formData.institution}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                    >
                      <option value="ESN">{formConfig.institution}</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Sınav Tarihi
                  </label>
                  <div className="relative">
                    <FaCalendarAlt className="absolute left-3 top-3 text-gray-400" />
                    <select
                      name="exam_date"
                      value={formData.exam_date}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 ${
                        errors.exam_date ? 'border-red-500' : 'border-gray-300'
                      }`}
                    >
                      <option value="">Seçiniz</option>
                      {formConfig.examDates.map((date, index) => (
                        <option key={index} value={date.label}>{date.label}</option>
                      ))}
                    </select>
                  </div>
                  {errors.exam_date && (
                    <p className="text-red-500 text-xs mt-1">{errors.exam_date}</p>
                  )}
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Sınav Oturumu
                  </label>
                  <div className="relative">
                    <FaClock className="absolute left-3 top-3 text-gray-400" />
                    <select
                      name="exam_session"
                      value={formData.exam_session}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 ${
                        errors.exam_session ? 'border-red-500' : 'border-gray-300'
                      }`}
                    >
                      <option value="">Seçiniz</option>
                      {formConfig.examSessions.map((session, index) => (
                        <option key={index} value={session.label}>{session.label}</option>
                      ))}
                    </select>
                  </div>
                  {errors.exam_session && (
                    <p className="text-red-500 text-xs mt-1">{errors.exam_session}</p>
                  )}
                </div>
              </div>
            </div>
          )}
          
          {/* Adım 2: Öğrenci Bilgileri */}
          {step === 2 && (
            <div className="transition-opacity duration-300">
              <h2 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 flex items-center text-indigo-800">
                <FaUser className="mr-2 text-sm sm:text-base" /> Öğrenci Bilgileri
              </h2>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 sm:gap-x-6 lg:gap-x-8 gap-y-3 sm:gap-y-4">
                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> T.C. Kimlik Numarası
                  </label>
                  <div className="relative">
                    <FaIdCard className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="text"
                      name="student_id"
                      value={formData.student_id}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 ${
                        errors.student_id ? 'border-red-500' : 'border-gray-300'
                      }`}
                      maxLength={11}
                      placeholder="11 haneli TC kimlik no"
                    />
                  </div>
                  {errors.student_id && (
                    <p className="text-red-500 text-xs mt-1">{errors.student_id}</p>
                  )}
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Öğrenci Adı
                  </label>
                  <div className="relative">
                    <FaUser className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="text"
                      name="student_name"
                      value={formData.student_name}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 capitalize ${
                        errors.student_name ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Öğrencinin adı"
                    />
                  </div>
                  {errors.student_name && (
                    <p className="text-red-500 text-xs mt-1">{errors.student_name}</p>
                  )}
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Öğrenci Soyadı
                  </label>
                  <div className="relative">
                    <FaUser className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="text"
                      name="student_surname"
                      value={formData.student_surname}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 capitalize ${
                        errors.student_surname ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Öğrencinin soyadı"
                    />
                  </div>
                  {errors.student_surname && (
                    <p className="text-red-500 text-xs mt-1">{errors.student_surname}</p>
                  )}
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    Doğum Tarihi (Opsiyonel)
                  </label>
                  <div className="relative">
                    <FaCalendarAlt 
                      className="absolute left-3 top-3 text-gray-400 cursor-pointer hover:text-indigo-500" 
                      onClick={() => {
                        const input = document.querySelector('input[name="student_birth_year"]');
                        if (input) {
                          input.focus();
                          input.click();
                        }
                      }}
                    />
                    <input
                      type="date"
                      name="student_birth_year"
                      value={formData.student_birth_year}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 cursor-pointer"
                      placeholder="GG.AA.YYYY"
                      style={{ colorScheme: 'light' }}
                    />
                  </div>
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    Telefon (Opsiyonel)
                  </label>
                  <div className="relative">
                    <FaPhone className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="tel"
                      name="student_phone"
                      value={formData.student_phone}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                      placeholder="Öğrenci telefon numarası"
                    />
                  </div>
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Okul
                  </label>
                  <div className="relative">
                    <FaSchool className="absolute left-3 top-3 text-gray-400" />
                    <select
                      name="school"
                      value={formData.school}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 ${
                        errors.school ? 'border-red-500' : 'border-gray-300'
                      }`}
                    >
                      <option value="">Okul Seçin</option>
                      <option value="Cumhuriyet Ortaokulu">Cumhuriyet Ortaokulu</option>
                      <option value="31 Ağustos Ortaokulu">31 Ağustos Ortaokulu</option>
                      <option value="İmam Hatip Ortaokulu">İmam Hatip Ortaokulu</option>
                      <option value="Halime Ali Kaya Ortaokulu">Halime Ali Kaya Ortaokulu</option>
                      <option value="Diğer">Diğer</option>
                    </select>
                  </div>
                  {errors.school && (
                    <p className="text-red-500 text-xs mt-1">{errors.school}</p>
                  )}
                </div>
              </div>
            </div>
          )}
          
          {/* Adım 3: Veli Bilgileri */}
          {step === 3 && (
            <div className="transition-opacity duration-300">
              <h2 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 flex items-center text-indigo-800">
                <FaUser className="mr-2 text-sm sm:text-base" /> Veli Bilgileri
              </h2>
              
              {errors.parent_phone && (
                <div className="mb-4 sm:mb-6 bg-red-50 border-l-4 border-red-500 p-3 sm:p-4 rounded">
                  <div className="flex">
                    <FaExclamationTriangle className="text-red-500 mr-2 sm:mr-3 flex-shrink-0 text-sm sm:text-base" />
                    <p className="text-red-700 text-sm sm:text-base">{errors.parent_phone}</p>
                  </div>
                </div>
              )}
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 sm:gap-x-6 lg:gap-x-8 gap-y-3 sm:gap-y-4">
                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Baba Ad Soyad
                  </label>
                  <div className="relative">
                    <FaUser className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="text"
                      name="father_name"
                      value={formData.father_name}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 capitalize ${
                        errors.father_name ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Baba adı soyadı"
                    />
                  </div>
                  {errors.father_name && (
                    <p className="text-red-500 text-xs mt-1">{errors.father_name}</p>
                  )}
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Baba Telefon
                  </label>
                  <div className="relative">
                    <FaPhone className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="tel"
                      name="father_phone"
                      value={formData.father_phone}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 ${
                        errors.father_phone ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Başında 0 olmadan yazınız"
                    />
                  </div>
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Anne Ad Soyad
                  </label>
                  <div className="relative">
                    <FaUser className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="text"
                      name="mother_name"
                      value={formData.mother_name}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 capitalize ${
                        errors.mother_name ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Anne adı soyadı"
                    />
                  </div>
                  {errors.mother_name && (
                    <p className="text-red-500 text-xs mt-1">{errors.mother_name}</p>
                  )}
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700">
                    <span className="text-red-500">*</span> Anne Telefon
                  </label>
                  <div className="relative">
                    <FaPhone className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="tel"
                      name="mother_phone"
                      value={formData.mother_phone}
                      onChange={handleChange}
                      className={`w-full border rounded-lg p-2 pl-10 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 ${
                        errors.mother_phone ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Başında 0 olmadan yazınız"
                    />
                  </div>
                </div>
              </div>
              
              <div className="mt-6 sm:mt-8 p-3 sm:p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                <div className="flex items-start">
                  <div className="flex items-center h-5 flex-shrink-0">
                    <input
                      id="consent"
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                    />
                  </div>
                  <label htmlFor="consent" className="ml-2 text-xs sm:text-sm text-gray-700">
                    <span className="text-red-500">*</span> Formda yazılı iletişim adreslerime gelecek her türlü bilgi ve
                    gelişme duyurularını almayı kabul ediyorum.
                  </label>
                </div>
              </div>
            </div>
          )}
          
          {/* Form Butonları */}
          <div className="flex flex-col sm:flex-row justify-between items-center mt-6 sm:mt-8 gap-3 sm:gap-0">
            {step > 1 ? (
              <button
                type="button"
                onClick={handlePrevStep}
                className="w-full sm:w-auto bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 sm:py-3 px-4 sm:px-6 text-sm sm:text-base rounded-lg transition-colors flex items-center justify-center"
              >
                <FaArrowRight className="mr-1 sm:mr-2 transform rotate-180 text-sm sm:text-base" /> Geri
              </button>
            ) : (
              <div className="hidden sm:block"></div> // Boş div ile hizalama korunur
            )}
            
            {step < 3 ? (
              <button
                type="button"
                onClick={handleNextStep}
                className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 sm:py-3 px-4 sm:px-6 text-sm sm:text-base rounded-lg transition-colors flex items-center justify-center"
              >
                İleri <FaArrowRight className="ml-1 sm:ml-2 text-sm sm:text-base" />
              </button>
            ) : (
              <button
                type="submit"
                disabled={loading}
                className={`w-full sm:w-auto ${
                  loading ? 'bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-700'
                } text-white font-medium py-2 sm:py-3 px-4 sm:px-6 text-sm sm:text-base rounded-lg transition-colors flex items-center justify-center`}
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-1 sm:mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    <FaPaperPlane className="mr-1 sm:mr-2 text-sm sm:text-base" /> Kaydı Gönder
                  </>
                )}
              </button>
            )}
          </div>
        </form>
        
        {/* Başarılı Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl p-4 sm:p-6 lg:p-8 w-full max-w-sm sm:max-w-md text-center animate-fadeIn">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <FaCheckCircle className="text-green-500 text-2xl sm:text-3xl lg:text-4xl" />
              </div>
              
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 mb-2">
                Kayıt Başarılı!
              </h2>
              
              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                Sınav kaydınız başarıyla oluşturuldu. Sınav günü ve saatinde sizleri bekliyoruz.
              </p>
              
              <div className="bg-blue-50 border-l-4 border-blue-500 p-3 sm:p-4 rounded mb-4 sm:mb-6 text-left">
                <div className="flex">
                  <FaInfoCircle className="text-blue-500 mr-2 sm:mr-3 flex-shrink-0 mt-1 text-sm sm:text-base" />
                  <div>
                    <p className="text-blue-700 font-medium text-sm sm:text-base">Önemli Hatırlatma</p>
                    <p className="text-blue-600 text-xs sm:text-sm mt-1">
                      Sınava kimlik belgenizle gelmeyi ve sınavdan 15 dakika önce salonunuzda olmayı unutmayın.
                    </p>
                  </div>
                </div>
              </div>
              
              <button
                onClick={handleCloseModal}
                className="w-full px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700 transition-colors font-medium"
              >
                Tamam
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExamRegistrationForm;
